// MANAGING DIABETES section — all 2026 assets (Managing Diabetes folder + jpgs/).
import { pdf2026, thumb2026 } from "./assets";

const CAT = "Managing Diabetes";
const card = (title, file) => ({
  title,
  pdf: pdf2026(CAT, `${file}.pdf`),
  thumb: thumb2026(`${file}.jpg`),
});

const managingDiabetesCards = [
  card("Lifestyle Pillars To Prevent & Manage Type 2 Diabetes", "Lifestyle Pillars To Prevent & Manage Type 2 Diabetes"),
  card("Understanding Gestational Diabetes", "Understanding Gestational Diabetes"),
  card("Green Light Foods", "Green Light Foods"),
  card("Diet and Diabetes Recipes of Success", "Diet and Diabetes Recipes of Success"),
  card("Hypoglycemia in Diabetes", "Hypoglycemia in Diabetes"),
  card("Understanding Polycystic Ovary Syndrome (PCOS)", "Understanding Polycystic Ovary Syndrome (PCOS)"),
];

export default managingDiabetesCards;
